import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Grid,
  Tooltip,
  Typography,
  DialogActions,
  Button,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { SelectResult } from '../../../../components/select/select-chain.component';
import { ServiceList } from '../service-list';
import { useSaveData } from '../../../../hooks/useSaveData';
import { workOrdersApiKeyStore } from '../../../../api/workorders-api-key-store';
import { useState } from 'react';
import WorkOrderLogList from './work-order-log-list';

const styling = {
  dialogTitleStyle: { padding: '16px 24px 0' },
  contentPadding: { paddingTop: '30px' },
  buttonPadding: { paddingTop: '20px' },
  tabHeading: { fontWeight: 'bold' },
  buttonStyle: { width: '130px' },
};

interface WorkorderLogDialogProps {
  open: boolean;
  onClose: () => void;
}

export const WorkOrderLogDialog = ({ open, onClose }: WorkorderLogDialogProps) => {
  // const [selectedServiceID, setSelectedServiceID] = useState<number>(0);
  const handleDialogClose = () => {
    onClose();
  };

  return (
    <Dialog
      open={open}
      fullWidth={true}
      maxWidth={'lg'}
      // onClose={handleDialogClose}
      aria-labelledby="dialog-title"
      aria-describedby="dialog-description"
    >
      <DialogTitle id="dialog-title" style={styling.dialogTitleStyle}>
        WORK ORDER LOGS
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={handleDialogClose}
        sx={{
          position: 'absolute',
          right: 10,
          top: 3,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <Tooltip title={<Typography variant="body1">Close</Typography>}>
          <CloseIcon />
        </Tooltip>
      </IconButton>
      <DialogContent dividers style={styling.contentPadding} className="popupDilog selectServiceList">
        <WorkOrderLogList />
      </DialogContent>
      <div style={{ padding: '5px', paddingLeft: '16px', paddingRight: '16px' }}>
        <DialogActions className="spaceBetween">
          <Button variant="outlined" style={{ width: '130px' }} onClick={handleDialogClose}>
            Cancel
          </Button>
          {/* <Button
            type={'button'}
            variant="contained"
            disableElevation={true}
            style={styling.buttonStyle}
            disabled={isSaving || !selectedServiceID}
            onClick={handleSaveClick}
          >
            Save
          </Button> */}
        </DialogActions>
      </div>
    </Dialog>
  );
};
